module.exports = __webpack_public_path__ + "img/avatar_real_3.7b1d7858.jpg";